import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  TextField,
  Button,
  Container,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  Box,
  Grid,
} from "@mui/material";
import api from "../../api/api";

const Create = ({ setWarning, handleOpenSnackbar, onSave }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      docNumber: "",
      role: "ADMIN",
      phone: "",
    },
  });

  const onSubmit = (data) => {
    api.post("/users", data).then((res) => {
      if (res.status === 200 || res.status === 201) {
        setWarning({
          type: "success",
          message: "Colaborador criado com sucesso!",
        });
        handleOpenSnackbar();
        onSave();
      } else {
        setWarning({
          type: "error",
          message: "Falha ao criar o colaborador!",
        });
        handleOpenSnackbar();
      }
    });
  };

  return (
    <Box sx={{ padding: 5 }}>
      <Typography variant="h5" marginBottom={3}>
        Criar Colaborador
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("name", { required: "Nome é obrigatório" })}
              label="Nome"
              variant="outlined"
              fullWidth
              error={!!errors.name}
              helperText={errors.name?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("email", {
                required: "Email é obrigatório",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email address",
                },
              })}
              label="Email"
              variant="outlined"
              fullWidth
              error={!!errors.email}
              helperText={errors.email?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("password", {
                required: "Senha é obrigatório",
                minLength: {
                  value: 6,
                  message: "A senha deve possuir ao menos 6 caracteres",
                },
              })}
              label="Senha"
              type="password"
              variant="outlined"
              fullWidth
              error={!!errors.password}
              helperText={errors.password?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("confirmPassword", {
                required: "Confirmação de senha é obrigatório",
                minLength: {
                  value: 6,
                  message:
                    "A confirmação de senha deve possuir ao menos 6 caracteres",
                },
              })}
              label="Confirmar Senha"
              type="password"
              variant="outlined"
              fullWidth
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword?.message}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("docNumber", {
                required: "CPF/CNPJ é obrigatório",
              })}
              label="CPF/CNPJ"
              variant="outlined"
              fullWidth
              error={!!errors.docNumber}
              helperText={errors.docNumber?.message}
            />
          </Grid>
          <TextField
            {...register("role", {
              required: "Cargo é obrigatório",
            })}
            value="ADMIN"
            label="Cargo"
            variant="outlined"
            fullWidth
            InputProps={{
              readOnly: true,
            }}
            sx={{ display: "none" }}
            error={!!errors.role}
            helperText={errors.role?.message}
          />
          <Grid item xs={12} sm={6}>
            <TextField
              {...register("phone", {
                required: "Número de Telefone é obrigatório",
              })}
              label="Número de Telefone"
              variant="outlined"
              fullWidth
              error={!!errors.phone}
              helperText={errors.phone?.message}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 2 }}
            >
              Criar
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default Create;
